// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3C%3Fxml version=%271.0%27 encoding=%27UTF-8%27%3F%3E%3Csvg id=%27_Слой_2%27 data-name=%27Слой 2%27 xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 196.31 483.07%27%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: %2331c9ca; isolation: isolate; opacity: .07; %7D %3C/style%3E%3C/defs%3E%3Cg id=%27_Слой_1-2%27 data-name=%27Слой 1%27%3E%3Cpath class=%27cls-1%27 d=%27m74.49,0s-29.78,94.01-1.76,140.62c28.01,46.62,123.59,95.02,123.59,141.66s-93.93,200.79-93.93,200.79c0,0,21.42-120.11,13.19-161.35C106.99,278.77,5.16,185.52.22,142.44-4.72,99.37,74.49,0,74.49,0h0Z%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2718%27 height=%2718%27 viewBox=%270 0 18 18%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M8.99995 17.8002C11.3339 17.8002 13.5722 16.8731 15.2225 15.2227C16.8728 13.5724 17.7999 11.3341 17.7999 9.00019C17.7999 6.66629 16.8728 4.42798 15.2225 2.77766C13.5722 1.12734 11.3339 0.200195 8.99995 0.200195C6.66605 0.200195 4.42773 1.12734 2.77741 2.77766C1.12709 4.42798 0.199951 6.66629 0.199951 9.00019C0.199951 11.3341 1.12709 13.5724 2.77741 15.2227C4.42773 16.8731 6.66605 17.8002 8.99995 17.8002ZM13.0777 7.57789C13.278 7.37043 13.3889 7.09257 13.3864 6.80415C13.3839 6.51574 13.2682 6.23984 13.0642 6.03589C12.8603 5.83195 12.5844 5.71626 12.296 5.71375C12.0076 5.71125 11.7297 5.82212 11.5223 6.0225L7.89995 9.6448L6.47765 8.2225C6.27019 8.02212 5.99233 7.91125 5.70391 7.91375C5.41549 7.91626 5.1396 8.03195 4.93565 8.23589C4.7317 8.43984 4.61602 8.71574 4.61351 9.00415C4.611 9.29257 4.72188 9.57043 4.92225 9.77789L7.12225 11.9779C7.32853 12.1841 7.60827 12.3 7.89995 12.3C8.19163 12.3 8.47137 12.1841 8.67765 11.9779L13.0777 7.57789Z%27 fill=%27white%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Tariff_tariffs__cAdJB {
  width: 100%;
  gap: 30px;
  align-items: center;
  max-width: calc(80vw - 220px);
  margin: 0 auto;
  position: relative;
}
@media (max-width: 768px) {
  .Tariff_tariffs__cAdJB {
    max-width: 80vw;
  }
  .Tariff_tariffs__cAdJB .swiper-button-next {
    right: 40px !important;
  }
  .Tariff_tariffs__cAdJB .swiper-button-prev {
    left: 40px !important;
  }
}
@media (max-width: 530px) {
  .Tariff_tariffs__cAdJB {
    max-width: 70vw;
  }
  .Tariff_tariffs__cAdJB .swiper-button-next {
    right: -40px !important;
  }
  .Tariff_tariffs__cAdJB .swiper-button-prev {
    left: -40px !important;
  }
}
.Tariff_tariffs__cAdJB .swiper-horizontal {
  padding: 0 0 30px 0;
  position: static;
}
.Tariff_tariffs__cAdJB .swiper-button-next {
  right: -44px;
  top: calc(50% - 44px);
  color: #1DB5B6;
  width: 44px;
  background: #fff;
  border-radius: 50%;
  padding: 5px 3px 5px 8px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
}
.Tariff_tariffs__cAdJB .swiper-button-prev {
  left: -44px;
  top: calc(50% - 44px);
  color: #1DB5B6;
  width: 44px;
  background: #fff;
  border-radius: 50%;
  padding: 5px 8px 5px 3px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
}
.Tariff_tariffs__cAdJB .swiper-button-prev:after {
  font-size: 25px !important;
}
.Tariff_tariffs__cAdJB .swiper-button-next:after {
  font-size: 25px !important;
}
.Tariff_tariffs__cAdJB .swiper-wrapper {
  align-items: flex-end;
}
.Tariff_tariffs__cAdJB .swiper-scrollbar-drag {
  background: #1DB5B6;
}

.Tariff_container__F2n\\+K, .Tariff_container_recommend__bzUn5, .Tariff_container_archive__oNu0\\+, .Tariff_container_active__04EKG, .Tariff_container_default__\\+nlY1 {
  border-radius: 10px;
  background: #FFF;
  padding: 25px 30px;
  width: 230px;
  min-width: 230px;
  height: min-content;
  margin: 0 auto;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
}
.Tariff_container_active__04EKG {
  border: 1px solid #FFC581;
  padding-top: 57px;
  position: relative;
}
.Tariff_container_archive__oNu0\\+ .Tariff_period__CIGHW {
  color: #758282;
}
.Tariff_container_archive__oNu0\\+ .Tariff_number__HsbWs {
  background: #899696;
}
.Tariff_container_recommend__bzUn5 {
  position: relative;
  border: 1px solid #31C9CA;
}
.Tariff_container_recommend__bzUn5:after {
  position: absolute;
  top: -35px;
  z-index: 848;
  pointer-events: none;
  width: 100%;
  right: -45px;
  height: 470px;
  content: "";
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.Tariff_title__gkvNo {
  color: #242424;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28.571px;
}

.Tariff_period__CIGHW {
  color: #1DB5B6;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 25px 0;
}

.Tariff_description__K95qe {
  color: #899696;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  height: 25px;
}

.Tariff_number__HsbWs {
  color: #FFF;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  border-radius: 20px;
  background: #1DB5B6;
  padding: 0 5px;
  width: auto;
}

.Tariff_text__g2mV2 {
  color: #899696;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.Tariff_monitor_limit__UG914, .Tariff_monitor_limit_max__vWfJx, .Tariff_instances_limit__ernjH {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.Tariff_instances_limit__ernjH {
  align-items: center;
}

.Tariff_monitor_limit_max__vWfJx {
  align-items: center;
}

.Tariff_price__URvGv {
  margin: 25px 0;
}
.Tariff_price_cost__IjpNZ {
  color: #575757;
  font-family: Inter;
  font-size: 37px;
  font-style: normal;
  font-weight: 700;
  line-height: 28.571px;
  margin-top: 12px;
}
.Tariff_price_cost__IjpNZ span {
  font-size: 17px;
}

.Tariff_button_container__7U05d {
  display: flex;
  justify-content: center;
}
.Tariff_button_free__1jHXC {
  padding: 15px 20px;
  background: #F6F6F6;
  color: #7D8797;
}
.Tariff_button_active__WK1Jd {
  padding: 15px 20px;
  background: #FE974A;
}
.Tariff_button_active__WK1Jd:hover {
  background: #FE974A;
}
.Tariff_button_default__\\+j3Gb {
  padding: 15px 20px;
  background: #1DB5B6;
}

.Tariff_label_active__1MJQD {
  position: absolute;
  top: 0;
  padding: 10px 12px;
  border-radius: 0px 0px 12px 12px;
  background: #FE974A;
  margin: 0 auto;
  left: 0;
  right: 0;
  width: min-content;
  display: flex;
  gap: 10px;
  align-items: center;
  color: #FFF;
  font-family: Inter;
  font-size: 12px;
  font-weight: 700;
  line-height: 11px;
  min-width: 182px;
  justify-content: center;
}
.Tariff_label_active__1MJQD:before {
  content: "";
  width: 18px;
  height: 18px;
  display: block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.Tariff_label_recommended__42tQm {
  position: absolute;
  top: -35px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  background-color: #ECFFFE;
  z-index: 0;
  width: 100%;
  left: 0;
  border-radius: 12px 12px 0px 0px;
  padding: 7px 0;
}
.Tariff_label_recommended__42tQm svg {
  width: 73px;
  height: 15px;
  margin-bottom: 5px;
}
.Tariff_label_recommended__42tQm span {
  color: #1DB5B6;
  font-family: Inter;
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 1.26px;
  text-transform: uppercase;
}

.Tariff_arrow_left__wrKJP {
  position: absolute;
  width: min-content;
  z-index: 10;
  left: 0;
  border-radius: 50%;
  background: #31C9CA;
  padding: 6px 8px 6px 6px;
}
.Tariff_arrow_right__VV7eH {
  position: absolute;
  width: min-content;
  z-index: 10;
  right: 0;
  border-radius: 50%;
  background: #31C9CA;
  padding: 6px 6px 6px 8px;
}

.Tariff_h3__jmXQ\\+ {
  margin-bottom: 30px;
  padding-top: 30px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Tariffs/Tariff.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;AAEF;AAAE;EARF;IASI,eAAA;EAGF;EADE;IACE,sBAAA;EAGJ;EAAE;IACE,qBAAA;EAEJ;AACF;AAAE;EAnBF;IAoBI,eAAA;EAGF;EADE;IACE,uBAAA;EAGJ;EAAE;IACE,sBAAA;EAEJ;AACF;AACE;EACE,mBAAA;EACA,gBAAA;AACJ;AAEE;EACE,YAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,8CAAA;AAAJ;AAGE;EACE,WAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,8CAAA;AADJ;AAIE;EACE,0BAAA;AAFJ;AAKE;EACE,0BAAA;AAHJ;AAME;EACE,qBAAA;AAJJ;AAOE;EACE,mBAAA;AALJ;;AASA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,8CAAA;AANF;AAYE;EAEE,yBAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;AAiBI;EACE,cAAA;AAfN;AAkBI;EACE,mBAAA;AAhBN;AAoBE;EAEE,kBAAA;EACA,yBAAA;AAnBJ;AAqBI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,4BAAA;EACA,yDAAA;AAnBN;;AAwBA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AArBF;;AAwBA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AArBF;;AAwBA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AArBF;;AAwBA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AArBF;;AAwBA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AArBF;;AAwBA;EAEE,mBAAA;AAtBF;;AAyBA;EAEE,mBAAA;AAvBF;;AA0BA;EACE,cAAA;AAvBF;AAyBE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AAvBJ;AAyBI;EACE,eAAA;AAvBN;;AA6BE;EACE,aAAA;EACA,uBAAA;AA1BJ;AA6BE;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AA3BJ;AA8BE;EACE,kBAAA;EACA,mBAAA;AA5BJ;AA8BI;EACE,mBAAA;AA5BN;AAgCE;EACE,kBAAA;EACA,mBAAA;AA9BJ;;AAmCE;EACE,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAhCJ;AAkCI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,yDAAA;AAhCN;AAoCE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,OAAA;EACA,gCAAA;EACA,cAAA;AAlCJ;AAoCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAlCN;AAqCI;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAnCN;;AAyCE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;AAtCJ;AAyCE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;AAvCJ;;AA2CA;EACE,mBAAA;EACA,4BAAA;AAxCF","sourcesContent":[".tariffs {\n  width: 100%;\n  gap: 30px;\n  align-items: center;\n  max-width: calc(80vw - 220px);\n  margin: 0 auto;\n  position: relative;\n\n  @media(max-width: 768px) {\n    max-width: 80vw;\n\n    :global(.swiper-button-next ) {\n      right: 40px !important;\n    }\n\n    :global(.swiper-button-prev) {\n      left: 40px !important;\n    }\n  }\n  @media(max-width: 530px) {\n    max-width: 70vw;\n\n    :global(.swiper-button-next ) {\n      right: -40px !important;\n    }\n\n    :global(.swiper-button-prev) {\n      left: -40px !important;\n    }\n  }\n\n  :global(.swiper-horizontal) {\n    padding: 0 0 30px 0;\n    position: static;\n  }\n\n  :global(.swiper-button-next ) {\n    right: -44px;\n    top: calc(50% - 44px);\n    color: #1DB5B6;\n    width: 44px;\n    background: #fff;\n    border-radius: 50%;\n    padding: 5px 3px 5px 8px;\n    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.10);\n  }\n\n  :global(.swiper-button-prev) {\n    left: -44px;\n    top: calc(50% - 44px);\n    color: #1DB5B6;\n    width: 44px;\n    background: #fff;\n    border-radius: 50%;\n    padding: 5px 8px 5px 3px;\n    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.10);\n  }\n\n  :global(.swiper-button-prev:after) {\n    font-size: 25px !important;\n  }\n\n  :global(.swiper-button-next:after) {\n    font-size: 25px !important;\n  }\n\n  :global(.swiper-wrapper) {\n    align-items: flex-end;\n  }\n\n  :global(.swiper-scrollbar-drag) {\n    background: #1DB5B6;\n  }\n}\n\n.container {\n  border-radius: 10px;\n  background: #FFF;\n  padding: 25px 30px;\n  width: 230px;\n  min-width: 230px;\n  height: min-content;\n  margin: 0 auto;\n  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.10);\n\n  &_default {\n    @extend .container;\n  }\n\n  &_active {\n    @extend .container;\n    border: 1px solid #FFC581;\n    padding-top: 57px;\n    position: relative;\n  }\n\n  &_archive {\n    @extend .container;\n\n    & .period {\n      color: #758282;\n    }\n\n    & .number {\n      background: #899696;\n    }\n  }\n\n  &_recommend {\n    @extend .container;\n    position: relative;\n    border: 1px solid #31C9CA;\n\n    &:after {\n      position: absolute;\n      top: -35px;\n      z-index: 848;\n      pointer-events: none;\n      width: 100%;\n      right: -45px;\n      height: 470px;\n      content: \"\";\n      background-repeat: no-repeat;\n      background-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='_Слой_2' data-name='Слой 2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 196.31 483.07'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: %2331c9ca; isolation: isolate; opacity: .07; %7D %3C/style%3E%3C/defs%3E%3Cg id='_Слой_1-2' data-name='Слой 1'%3E%3Cpath class='cls-1' d='m74.49,0s-29.78,94.01-1.76,140.62c28.01,46.62,123.59,95.02,123.59,141.66s-93.93,200.79-93.93,200.79c0,0,21.42-120.11,13.19-161.35C106.99,278.77,5.16,185.52.22,142.44-4.72,99.37,74.49,0,74.49,0h0Z'/%3E%3C/g%3E%3C/svg%3E\");\n    }\n  }\n}\n\n.title {\n  color: #242424;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 28.571px;\n}\n\n.period {\n  color: #1DB5B6;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  margin: 25px 0;\n}\n\n.description {\n  color: #899696;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  height: 25px;\n}\n\n.number {\n  color: #FFF;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  border-radius: 20px;\n  background: #1DB5B6;\n  padding: 0 5px;\n  width: auto;\n}\n\n.text {\n  color: #899696;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n}\n\n.monitor_limit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.instances_limit {\n  @extend .monitor_limit;\n  align-items: center;\n}\n\n.monitor_limit_max {\n  @extend .monitor_limit;\n  align-items: center;\n}\n\n.price {\n  margin: 25px 0;\n\n  &_cost {\n    color: #575757;\n    font-family: Inter;\n    font-size: 37px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28.571px;\n    margin-top: 12px;\n\n    & span {\n      font-size: 17px;\n    }\n  }\n}\n\n.button {\n  &_container {\n    display: flex;\n    justify-content: center;\n  }\n\n  &_free {\n    padding: 15px 20px;\n    background: #F6F6F6;\n    color: #7D8797;\n  }\n\n  &_active {\n    padding: 15px 20px;\n    background: #FE974A;\n\n    &:hover {\n      background: #FE974A;\n    }\n  }\n\n  &_default {\n    padding: 15px 20px;\n    background: #1DB5B6;\n  }\n}\n\n.label {\n  &_active {\n    position: absolute;\n    top: 0;\n    padding: 10px 12px;\n    border-radius: 0px 0px 12px 12px;\n    background: #FE974A;\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n    width: min-content;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    color: #FFF;\n    font-family: Inter;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 11px;\n    min-width: 182px;\n    justify-content: center;\n\n    &:before {\n      content: '';\n      width: 18px;\n      height: 18px;\n      display: block;\n      background-image: url(\"data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.99995 17.8002C11.3339 17.8002 13.5722 16.8731 15.2225 15.2227C16.8728 13.5724 17.7999 11.3341 17.7999 9.00019C17.7999 6.66629 16.8728 4.42798 15.2225 2.77766C13.5722 1.12734 11.3339 0.200195 8.99995 0.200195C6.66605 0.200195 4.42773 1.12734 2.77741 2.77766C1.12709 4.42798 0.199951 6.66629 0.199951 9.00019C0.199951 11.3341 1.12709 13.5724 2.77741 15.2227C4.42773 16.8731 6.66605 17.8002 8.99995 17.8002ZM13.0777 7.57789C13.278 7.37043 13.3889 7.09257 13.3864 6.80415C13.3839 6.51574 13.2682 6.23984 13.0642 6.03589C12.8603 5.83195 12.5844 5.71626 12.296 5.71375C12.0076 5.71125 11.7297 5.82212 11.5223 6.0225L7.89995 9.6448L6.47765 8.2225C6.27019 8.02212 5.99233 7.91125 5.70391 7.91375C5.41549 7.91626 5.1396 8.03195 4.93565 8.23589C4.7317 8.43984 4.61602 8.71574 4.61351 9.00415C4.611 9.29257 4.72188 9.57043 4.92225 9.77789L7.12225 11.9779C7.32853 12.1841 7.60827 12.3 7.89995 12.3C8.19163 12.3 8.47137 12.1841 8.67765 11.9779L13.0777 7.57789Z' fill='white'/%3E%3C/svg%3E\");\n    }\n  }\n\n  &_recommended {\n    position: absolute;\n    top: -35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 15px;\n    background-color: #ECFFFE;\n    z-index: 0;\n    width: 100%;\n    left: 0;\n    border-radius: 12px 12px 0px 0px;\n    padding: 7px 0;\n\n    svg {\n      width: 73px;\n      height: 15px;\n      margin-bottom: 5px;\n    }\n\n    span {\n      color: #1DB5B6;\n      font-family: Inter;\n      font-size: 10.5px;\n      font-weight: 500;\n      letter-spacing: 1.26px;\n      text-transform: uppercase;\n    }\n  }\n}\n\n.arrow {\n  &_left {\n    position: absolute;\n    width: min-content;\n    z-index: 10;\n    left: 0;\n    border-radius: 50%;\n    background: #31C9CA;\n    padding: 6px 8px 6px 6px;\n  }\n\n  &_right {\n    position: absolute;\n    width: min-content;\n    z-index: 10;\n    right: 0;\n    border-radius: 50%;\n    background: #31C9CA;\n    padding: 6px 6px 6px 8px;\n  }\n}\n\n.h3 {\n  margin-bottom: 30px;\n  padding-top: 30px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tariffs": `Tariff_tariffs__cAdJB`,
	"container": `Tariff_container__F2n+K`,
	"container_recommend": `Tariff_container_recommend__bzUn5`,
	"container_archive": `Tariff_container_archive__oNu0+`,
	"container_active": `Tariff_container_active__04EKG`,
	"container_default": `Tariff_container_default__+nlY1`,
	"period": `Tariff_period__CIGHW`,
	"number": `Tariff_number__HsbWs`,
	"title": `Tariff_title__gkvNo`,
	"description": `Tariff_description__K95qe`,
	"text": `Tariff_text__g2mV2`,
	"monitor_limit": `Tariff_monitor_limit__UG914`,
	"monitor_limit_max": `Tariff_monitor_limit_max__vWfJx`,
	"instances_limit": `Tariff_instances_limit__ernjH`,
	"price": `Tariff_price__URvGv`,
	"price_cost": `Tariff_price_cost__IjpNZ`,
	"button_container": `Tariff_button_container__7U05d`,
	"button_free": `Tariff_button_free__1jHXC`,
	"button_active": `Tariff_button_active__WK1Jd`,
	"button_default": `Tariff_button_default__+j3Gb`,
	"label_active": `Tariff_label_active__1MJQD`,
	"label_recommended": `Tariff_label_recommended__42tQm`,
	"arrow_left": `Tariff_arrow_left__wrKJP`,
	"arrow_right": `Tariff_arrow_right__VV7eH`,
	"h3": `Tariff_h3__jmXQ+`
};
export default ___CSS_LOADER_EXPORT___;
